import React, { useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { fr } from "date-fns/locale";

function ReactDatePicker({ value, onChange }) {
  const pickerRef = useRef();

  // ✅ convert string → Date
  const parsedValue = value ? new Date(value) : null;

  return (
    <div>
      <DatePicker
        selected={parsedValue}
        onChange={(date) => {
          onChange(date);
          setTimeout(() => pickerRef.current?.setOpen(false), 0);
        }}
        ref={pickerRef}
        locale={fr}
        dateFormat="dd/MM/yyyy"
        placeholderText="JJ/MM/AAAA"
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
      />
    </div>
  );
}

export default ReactDatePicker;
